document.addEventListener("DOMContentLoaded", function () {
      const siteHeader = document.querySelector(".site-header");
      const headerInner = document.querySelector(".site-header-inner");
      const prefersReducedMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      const partnershipUrl = "https://dpn.deeper.network/pages/dpn-app-cooperation-information";
      document.querySelectorAll("a.button").forEach(function (link) {
        const label = (link.textContent || "").replace(/\s+/g, " ").trim().toUpperCase();
        if (label.includes("JOIN PARTNERSHIP") || link.getAttribute("href") === "#join-partnership" || (link.href || "").includes("information@deeper.network")) {
          link.href = partnershipUrl;
        }
      });
      const topHeaderRestoreStyle = document.createElement("style");
      topHeaderRestoreStyle.id = "dpn-reseller-top-header-restore";
      topHeaderRestoreStyle.textContent = `
        @media (min-width: 901px) {
          body .site-header:not(.is-floating) {
            height: 75px !important;
            padding: 0 !important;
            color: #fff !important;
            background: #000 !important;
            box-shadow: none !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
          }

          body .site-header:not(.is-floating) .site-header-inner {
            display: grid !important;
            grid-template-columns: 290px minmax(0, 1fr) 120px !important;
            width: min(var(--nav-max), calc(100% - 112px)) !important;
            height: 74px !important;
            min-height: 74px !important;
            margin: 0 auto !important;
            padding: 0 !important;
            border: 0 !important;
            border-radius: 0 !important;
            color: #fff !important;
            background: transparent !important;
            box-shadow: none !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
            transform: none !important;
          }

          body .site-header:not(.is-floating) .site-nav-menu {
            gap: 24px !important;
            color: #fff !important;
            font-size: 16px !important;
            font-weight: 700 !important;
            line-height: 22px !important;
          }

          body .site-header:not(.is-floating) .site-nav-item,
          body .site-header:not(.is-floating) .site-nav-link,
          body .site-header:not(.is-floating) .site-nav-menu > a,
          body .site-header:not(.is-floating) .site-icon {
            min-height: 74px !important;
            height: 74px !important;
          }

          body .site-header:not(.is-floating) .site-nav-link,
          body .site-header:not(.is-floating) .site-nav-menu > a {
            padding: 0 !important;
            color: #fff !important;
            font-size: 16px !important;
            font-weight: 700 !important;
            line-height: 22px !important;
          }

          body .site-header:not(.is-floating) .site-nav-item--guide .site-nav-link {
            width: auto !important;
            max-width: none !important;
            justify-content: center !important;
            text-align: center !important;
          }

          body .site-header:not(.is-floating) .site-actions {
            width: auto !important;
            min-width: 0 !important;
          }

          body .site-header:not(.is-floating) .site-icon {
            width: 40px !important;
            flex: 0 0 40px !important;
            color: #fff !important;
          }
        }
      `;
      document.head.appendChild(topHeaderRestoreStyle);
      const headerPolishStyle = document.createElement("style");
      headerPolishStyle.id = "dpn-reseller-header-runtime-polish";
      headerPolishStyle.textContent = `
        @media (min-width: 901px) {
          .site-header {
            z-index: 320 !important;
          }

          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--vpn-products {
            top: var(--reseller-header-bottom, 120px) !important;
            transform: translate3d(0, -8px, 0) scale(0.985) !important;
          }

          .site-header:not(.is-floating) .has-dropdown:hover > .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          .site-header:not(.is-floating) .has-dropdown:focus-within > .site-dropdown.site-dropdown--products.site-dropdown--vpn-products {
            transform: translate3d(0, 0, 0) scale(1) !important;
          }

          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--bundle-products {
            width: min(960px, calc(100vw - 96px)) !important;
          }

          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .site-dropdown-inner {
            grid-template-columns: 250px minmax(0, 1fr) !important;
            gap: 28px !important;
            padding: 22px !important;
            border-color: rgba(255, 255, 255, 0.15) !important;
            color: #fff !important;
            background:
              radial-gradient(circle at 86% 8%, rgba(72, 128, 255, 0.16), transparent 34%),
              linear-gradient(180deg, rgba(20, 20, 20, 0.98), rgba(0, 0, 0, 0.98)) !important;
            box-shadow:
              0 28px 58px rgba(0, 0, 0, 0.34),
              inset 0 1px 0 rgba(255, 255, 255, 0.08) !important;
            backdrop-filter: blur(18px) saturate(150%) !important;
            -webkit-backdrop-filter: blur(18px) saturate(150%) !important;
          }

          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .site-dropdown-group strong,
          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .site-dropdown-group a,
          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .dropdown-product-title {
            color: rgba(255, 255, 255, 0.94) !important;
          }

          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .site-dropdown-group a {
            color: rgba(255, 255, 255, 0.72) !important;
          }

          .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .dropdown-product-grid.dropdown-product-grid--bundles {
            grid-template-columns: repeat(3, 184px) !important;
            justify-content: start !important;
            gap: 16px !important;
          }

          .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .dropdown-product-card {
            min-height: 266px !important;
            padding: 0 !important;
            border-radius: 10px !important;
            grid-template-rows: 166px auto !important;
            gap: 8px !important;
          }

          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .dropdown-product-card {
            border-color: rgba(255, 255, 255, 0.15) !important;
            background: linear-gradient(180deg, #171717 0%, #0c0c0c 100%) !important;
            box-shadow: none !important;
          }

          .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .dropdown-product-image {
            height: 166px !important;
            padding: 20px 16px 0 !important;
            border-radius: 0 !important;
            background: transparent !important;
          }

          .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .dropdown-product-image img {
            width: auto !important;
            max-width: 92% !important;
            max-height: 132px !important;
            margin: 0 auto !important;
            object-fit: contain !important;
          }

          .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .dropdown-product-title {
            max-width: 160px !important;
            min-height: 38px !important;
            margin: 0 auto !important;
            padding: 0 12px 20px !important;
            font-size: 16px !important;
            line-height: 1.12 !important;
            font-weight: 500 !important;
            text-align: center !important;
          }

          .site-header.is-floating .site-header-inner {
            grid-template-columns: 210px minmax(0, 1fr) 112px !important;
            width: min(1368px, calc(100% - 48px)) !important;
            padding: 0 22px !important;
          }

          .site-header.is-floating .site-nav-menu {
            gap: clamp(9px, 0.78vw, 14px) !important;
            font-size: 15px !important;
            font-weight: 600 !important;
          }

          .site-header.is-floating .site-nav-item {
            flex: 0 1 auto !important;
          }

          .site-header.is-floating .site-nav-item--guide {
            flex: 0 1 190px !important;
          }

          .site-header.is-floating .site-nav-item--guide .site-nav-link {
            width: 190px !important;
            max-width: 190px !important;
            justify-content: center !important;
            text-align: center !important;
          }

          .site-header.is-floating .site-actions {
            width: 112px !important;
            min-width: 112px !important;
          }

          .site-header.is-floating .site-icon {
            width: 34px !important;
            flex-basis: 34px !important;
          }

          .site-dropdown--vpn-products {
            z-index: 340 !important;
            background: #000 !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
          }

          .site-dropdown--vpn-products::before {
            content: "" !important;
            position: absolute !important;
            inset: 0 !important;
            z-index: 0 !important;
            background: #000 !important;
            pointer-events: none !important;
          }

          .site-dropdown--vpn-products .site-dropdown-inner {
            position: relative !important;
            z-index: 1 !important;
          }

          .site-header.is-floating .site-dropdown--vpn-products {
            top: 102px !important;
            background: rgba(255, 255, 255, 0.98) !important;
            backdrop-filter: blur(24px) saturate(165%) !important;
            -webkit-backdrop-filter: blur(24px) saturate(165%) !important;
          }

          .site-header.is-floating .site-dropdown--vpn-products::before {
            background: rgba(255, 255, 255, 0.98) !important;
          }

          .site-dropdown--vpn-products .site-dropdown-inner,
          .site-header.is-floating .site-dropdown--vpn-products .site-dropdown-inner {
            width: min(1284px, calc(100vw - 96px)) !important;
            grid-template-columns: 220px minmax(0, 1fr) !important;
            gap: 28px !important;
          }

          .site-dropdown--vpn-products .site-dropdown-group strong,
          .site-header.is-floating .site-dropdown--vpn-products .site-dropdown-group strong {
            font-size: 22px !important;
            line-height: 1.12 !important;
            font-weight: 600 !important;
          }

          .site-dropdown--vpn-products .site-dropdown-group a,
          .site-header.is-floating .site-dropdown--vpn-products .site-dropdown-group a {
            font-size: 15px !important;
            line-height: 1.42 !important;
            font-weight: 400 !important;
            text-decoration: none !important;
          }

          .site-dropdown--vpn-products .dropdown-product-grid {
            grid-template-columns: repeat(5, 184px) !important;
            justify-content: start !important;
            gap: 16px !important;
          }

          .site-dropdown--vpn-products .dropdown-product-card,
          .site-header.is-floating .site-dropdown--vpn-products .dropdown-product-card {
            align-items: center !important;
            min-height: 266px !important;
            border-radius: 9px !important;
            text-decoration: none !important;
          }

          .site-dropdown--vpn-products .dropdown-product-image,
          .site-header.is-floating .site-dropdown--vpn-products .dropdown-product-image {
            height: 166px !important;
            padding: 20px 16px 0 !important;
            place-items: center !important;
          }

          .site-dropdown--vpn-products .dropdown-product-image img {
            max-width: 92% !important;
            max-height: 132px !important;
          }

          .site-dropdown--vpn-products .dropdown-product-copy {
            justify-items: center !important;
            gap: 8px !important;
            padding: 0 14px 21px !important;
          }

          .site-dropdown--vpn-products .dropdown-product-title,
          .site-header.is-floating .site-dropdown--vpn-products .dropdown-product-title {
            max-width: 160px !important;
            min-height: 38px !important;
            font-size: 16px !important;
            line-height: 1.12 !important;
            font-weight: 500 !important;
            text-align: center !important;
            display: -webkit-box !important;
            -webkit-box-orient: vertical !important;
            -webkit-line-clamp: 2 !important;
            overflow: hidden !important;
            text-decoration: none !important;
          }

          .site-dropdown--vpn-products .dropdown-product-subtitle,
          .site-header.is-floating .site-dropdown--vpn-products .dropdown-product-subtitle {
            max-width: 164px !important;
            font-size: 13px !important;
            line-height: 1.18 !important;
            font-weight: 400 !important;
            text-align: center !important;
            text-decoration: none !important;
          }

          .site-dropdown.site-dropdown--products.site-dropdown--vpn-products {
            background: #000 !important;
          }

          .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .site-dropdown-inner,
          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .site-dropdown-inner {
            width: min(1284px, calc(100vw - 96px)) !important;
            grid-template-columns: 220px minmax(0, 1fr) !important;
            gap: 28px !important;
          }

          .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .dropdown-product-grid.dropdown-product-grid--vpn {
            grid-template-columns: repeat(5, 184px) !important;
            justify-content: start !important;
            gap: 16px !important;
          }

          .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .dropdown-product-grid.dropdown-product-grid--vpn > .dropdown-product-card {
            width: 184px !important;
            min-height: 266px !important;
            border-radius: 9px !important;
          }

          .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .dropdown-product-grid.dropdown-product-grid--vpn > .dropdown-product-card .dropdown-product-title {
            font-size: 16px !important;
            line-height: 1.12 !important;
            font-weight: 500 !important;
          }

          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--vpn-products {
            left: 50% !important;
            right: auto !important;
            top: 82px !important;
            width: min(1320px, calc(100vw - 120px)) !important;
            max-width: calc(100vw - 120px) !important;
            padding: 26px 30px 30px !important;
            border: 1px solid rgba(126, 184, 255, 0.32) !important;
            border-radius: 28px !important;
            background:
              radial-gradient(circle at 16% 0%, rgba(231, 245, 255, 0.92), transparent 36%),
              linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(246, 251, 255, 0.96)) !important;
            box-shadow:
              0 34px 90px rgba(15, 23, 42, 0.16),
              0 1px 0 rgba(255, 255, 255, 0.9) inset !important;
            overflow: hidden !important;
            transform: translate3d(-50%, -8px, 0) scale(0.985) !important;
            transform-origin: 50% 0 !important;
          }

          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--vpn-products::before {
            border-radius: inherit !important;
            background:
              linear-gradient(90deg, rgba(255, 255, 255, 0.94), rgba(255, 255, 255, 0.72)),
              radial-gradient(circle at 88% 8%, rgba(37, 120, 255, 0.12), transparent 32%) !important;
          }

          .site-header.is-floating .has-dropdown:hover > .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          .site-header.is-floating .has-dropdown:focus-within > .site-dropdown.site-dropdown--products.site-dropdown--vpn-products {
            opacity: 1 !important;
            visibility: visible !important;
            pointer-events: auto !important;
            transform: translate3d(-50%, 0, 0) scale(1) !important;
          }

          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .site-dropdown-inner {
            width: 100% !important;
            max-width: none !important;
            margin: 0 !important;
          }

          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--vpn-products {
            position: fixed !important;
            top: 82px !important;
            left: 50% !important;
            right: auto !important;
            box-sizing: border-box !important;
            width: min(1320px, calc(100vw - 96px)) !important;
            max-width: calc(100vw - 96px) !important;
            padding: 26px 30px 30px !important;
            border: 1px solid rgba(126, 184, 255, 0.32) !important;
            border-radius: 28px !important;
            background:
              radial-gradient(circle at 16% 0%, rgba(231, 245, 255, 0.92), transparent 36%),
              radial-gradient(circle at 88% 8%, rgba(37, 120, 255, 0.12), transparent 32%),
              linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(246, 251, 255, 0.96)) !important;
            box-shadow:
              0 34px 90px rgba(15, 23, 42, 0.16),
              0 1px 0 rgba(255, 255, 255, 0.9) inset !important;
            overflow: hidden !important;
            transform: translate3d(-50%, -8px, 0) scale(0.985) !important;
            transform-origin: 50% 0 !important;
            backdrop-filter: blur(24px) saturate(165%) !important;
            -webkit-backdrop-filter: blur(24px) saturate(165%) !important;
          }

          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--vpn-products::before {
            inset: 0 !important;
            border-radius: inherit !important;
            background: linear-gradient(90deg, rgba(255, 255, 255, 0.94), rgba(255, 255, 255, 0.72)) !important;
          }

          .site-header.is-floating .has-dropdown:hover > .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          .site-header.is-floating .has-dropdown:focus-within > .site-dropdown.site-dropdown--products.site-dropdown--vpn-products {
            opacity: 1 !important;
            visibility: visible !important;
            pointer-events: auto !important;
            transform: translate3d(-50%, 0, 0) scale(1) !important;
          }

          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .site-dropdown-inner {
            width: 100% !important;
            max-width: none !important;
            margin: 0 !important;
            padding: 0 !important;
            border: 0 !important;
            border-radius: 0 !important;
            background: transparent !important;
            box-shadow: none !important;
            grid-template-columns: 220px minmax(0, 1fr) !important;
            gap: 28px !important;
            backdrop-filter: none !important;
            -webkit-backdrop-filter: none !important;
          }

          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .dropdown-product-grid.dropdown-product-grid--vpn {
            grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
            gap: 16px !important;
            justify-content: stretch !important;
          }

          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--vpn-products .dropdown-product-grid.dropdown-product-grid--vpn > .dropdown-product-card {
            width: auto !important;
            min-width: 0 !important;
            min-height: 266px !important;
            border-radius: 10px !important;
          }
        }
      `;
      document.head.appendChild(headerPolishStyle);

      const headerPlacementStyle = document.createElement("style");
      headerPlacementStyle.id = "dpn-reseller-header-placement-lock";
      headerPlacementStyle.textContent = `
        @media (min-width: 901px) {
          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--bundle-products,
          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--bundle-products {
            position: fixed !important;
            top: calc(var(--reseller-header-bottom, 102px) + 8px) !important;
            left: 50% !important;
            right: auto !important;
            box-sizing: border-box !important;
            padding-top: 0 !important;
            transform: translate3d(-50%, -8px, 0) scale(0.985) !important;
            transform-origin: 50% 0 !important;
            z-index: 340 !important;
          }

          .site-header:not(.is-floating) .has-dropdown:hover > .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          .site-header:not(.is-floating) .has-dropdown:focus-within > .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          .site-header:not(.is-floating) .has-dropdown:hover > .site-dropdown.site-dropdown--products.site-dropdown--bundle-products,
          .site-header:not(.is-floating) .has-dropdown:focus-within > .site-dropdown.site-dropdown--products.site-dropdown--bundle-products,
          .site-header.is-floating .has-dropdown:hover > .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          .site-header.is-floating .has-dropdown:focus-within > .site-dropdown.site-dropdown--products.site-dropdown--vpn-products,
          .site-header.is-floating .has-dropdown:hover > .site-dropdown.site-dropdown--products.site-dropdown--bundle-products,
          .site-header.is-floating .has-dropdown:focus-within > .site-dropdown.site-dropdown--products.site-dropdown--bundle-products {
            transform: translate3d(-50%, 0, 0) scale(1) !important;
          }

          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--vpn-products {
            width: min(1320px, calc(100vw - 96px)) !important;
            max-width: calc(100vw - 96px) !important;
          }

          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--bundle-products,
          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--bundle-products {
            width: min(960px, calc(100vw - 96px)) !important;
            max-width: calc(100vw - 96px) !important;
          }

          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--bundle-products {
            top: 82px !important;
          }

          .site-header:not(.is-floating) .site-dropdown.site-dropdown--products.site-dropdown--bundle-products {
            background: transparent !important;
          }

          .site-header.is-floating .site-dropdown.site-dropdown--products.site-dropdown--bundle-products .site-dropdown-inner {
            grid-template-columns: 250px minmax(0, 1fr) !important;
            gap: 28px !important;
            padding: 22px !important;
            border-color: rgba(126, 184, 255, 0.25) !important;
            background: rgba(255, 255, 255, 0.94) !important;
            box-shadow:
              0 24px 60px rgba(15, 23, 42, 0.12),
              inset 0 1px 0 rgba(255, 255, 255, 0.76) !important;
          }
        }
      `;
      document.head.appendChild(headerPlacementStyle);
      const topHeaderRestoreFinalStyle = topHeaderRestoreStyle.cloneNode(true);
      topHeaderRestoreFinalStyle.id = "dpn-reseller-top-header-restore-final";
      document.head.appendChild(topHeaderRestoreFinalStyle);

      function updateHeader() {
        if (!siteHeader) return;
        siteHeader.classList.toggle("is-floating", window.scrollY > 34);
        document.documentElement.style.setProperty("--reseller-header-bottom", Math.ceil(siteHeader.getBoundingClientRect().bottom) + "px");
      }

      updateHeader();
      window.addEventListener("scroll", updateHeader, { passive: true });
      window.addEventListener("resize", updateHeader, { passive: true });

      const navItems = Array.from(document.querySelectorAll(".has-dropdown"));
      navItems.forEach(function (item) {
        const trigger = item.querySelector(".site-nav-link");
        if (!trigger) return;

        function setOpen(isOpen) {
          trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
        }

        item.addEventListener("pointerenter", function () { setOpen(true); });
        item.addEventListener("pointerleave", function () { setOpen(false); });
        item.addEventListener("focusin", function () { setOpen(true); });
        item.addEventListener("focusout", function (event) {
          if (!item.contains(event.relatedTarget)) setOpen(false);
        });
        item.addEventListener("keydown", function (event) {
          if (event.key === "Escape") {
            setOpen(false);
            trigger.focus();
          }
        });
      });

      if (headerInner && !prefersReducedMotion) {
        function setHeaderGlow(edge, angle) {
          headerInner.style.setProperty("--edge-proximity", edge.toFixed(3));
          headerInner.style.setProperty("--cursor-angle", angle.toFixed(3) + "deg");
        }

        function getHeaderPointerMetrics(event) {
          const rect = headerInner.getBoundingClientRect();
          const x = event.clientX - rect.left;
          const y = event.clientY - rect.top;
          const cx = rect.width / 2;
          const cy = rect.height / 2;
          const dx = x - cx;
          const dy = y - cy;
          const kx = dx === 0 ? Infinity : cx / Math.abs(dx);
          const ky = dy === 0 ? Infinity : cy / Math.abs(dy);
          const edge = Math.min(Math.max(1 / Math.min(kx, ky), 0), 1) * 100;
          let angle = Math.atan2(dy, dx) * (180 / Math.PI) + 90;
          if (angle < 0) angle += 360;
          return { edge, angle };
        }

        headerInner.addEventListener("pointermove", function (event) {
          if (!siteHeader.classList.contains("is-floating")) return;
          const metrics = getHeaderPointerMetrics(event);
          setHeaderGlow(metrics.edge, metrics.angle);
        });

        headerInner.addEventListener("pointerleave", function () {
          setHeaderGlow(0, 45);
        });
      }

      const hero = document.querySelector(".hero");
      if (hero && !prefersReducedMotion) {
        let frame = 0;
        let targetX = 50;
        let targetY = 45;
        let currentX = 50;
        let currentY = 45;

        function renderHeroPointer() {
          currentX += (targetX - currentX) * 0.16;
          currentY += (targetY - currentY) * 0.16;

          hero.style.setProperty("--mx", currentX.toFixed(2) + "%");
          hero.style.setProperty("--my", currentY.toFixed(2) + "%");
          hero.style.setProperty("--hero-drift-x", ((currentX - 50) * 0.18).toFixed(2) + "px");
          hero.style.setProperty("--hero-drift-y", ((currentY - 50) * 0.14).toFixed(2) + "px");

          if (Math.abs(targetX - currentX) > 0.04 || Math.abs(targetY - currentY) > 0.04) {
            frame = window.requestAnimationFrame(renderHeroPointer);
          } else {
            frame = 0;
          }
        }

        function queueHeroPointer() {
          if (!frame) {
            frame = window.requestAnimationFrame(renderHeroPointer);
          }
        }

        hero.addEventListener("pointermove", function (event) {
          const rect = hero.getBoundingClientRect();
          targetX = Math.min(Math.max(((event.clientX - rect.left) / rect.width) * 100, 0), 100);
          targetY = Math.min(Math.max(((event.clientY - rect.top) / rect.height) * 100, 0), 100);
          queueHeroPointer();
        }, { passive: true });

        hero.addEventListener("pointerleave", function () {
          targetX = 50;
          targetY = 45;
          queueHeroPointer();
        });
      }

      const heroMainVideo = document.querySelector(".hero-main-video");
      const heroLoopVideo = document.querySelector(".hero-loop-video");
      if (hero && heroMainVideo && heroLoopVideo && !prefersReducedMotion) {
        let loopStarted = false;
        let loopHydrated = false;

        function hydrateLoopVideo() {
          if (loopHydrated) return;
          const src = heroLoopVideo.getAttribute("data-src");
          if (!src) return;
          loopHydrated = true;
          heroLoopVideo.src = src;
          heroLoopVideo.load();
        }

        function activateLoopVideo() {
          try {
            heroLoopVideo.currentTime = 0;
          } catch (error) {}
          heroLoopVideo.classList.add("is-active");
          hero.classList.add("is-video-looping");
          heroLoopVideo.play().catch(function () {});
          heroMainVideo.pause();
        }

        function startHandshakeLoop() {
          if (loopStarted) return;
          loopStarted = true;
          hydrateLoopVideo();

          if (heroLoopVideo.readyState >= 2) {
            activateLoopVideo();
          } else {
            heroLoopVideo.addEventListener("canplay", activateLoopVideo, { once: true });
          }
        }

        heroMainVideo.addEventListener("ended", startHandshakeLoop);

        heroMainVideo.addEventListener("loadedmetadata", function () {
          const duration = Number.isFinite(heroMainVideo.duration) ? heroMainVideo.duration : 7;
          const delay = Math.max(1800, (duration - 2) * 1000);
          window.setTimeout(hydrateLoopVideo, delay);
        }, { once: true });

        document.addEventListener("visibilitychange", function () {
          if (document.hidden) {
            heroMainVideo.pause();
            heroLoopVideo.pause();
          } else if (loopStarted) {
            hydrateLoopVideo();
            heroLoopVideo.play().catch(function () {});
          } else {
            heroMainVideo.play().catch(function () {});
          }
        });
      }

      const revealItems = Array.from(document.querySelectorAll(".reveal"));
      if ("IntersectionObserver" in window) {
        const observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add("is-visible");
              observer.unobserve(entry.target);
            }
          });
        }, { threshold: 0.16, rootMargin: "0px 0px -8% 0px" });
        revealItems.forEach(function (item) { observer.observe(item); });
      } else {
        revealItems.forEach(function (item) { item.classList.add("is-visible"); });
      }
    });
